import { useNavigate } from 'react-router-dom';
import TickersDisplayBar from '../../components/TickersDisplayBar';
import Header from '../MainPage/Header';
import Modal from '../../components/Modal';
import Notifs from '../../components/Notifications';
import AdblockChecker from '../../components/AdblockModal';
import HelpBody from './HelpBody';
import useDevice from '../MainPage/useMobileDetect';
import { PanelMobile } from '../MainPage/mobile';
import Loader from '../../components/common/Loader';

const HelpPage = () => {
  const { isMobile } = useDevice();
  const navigate = useNavigate();

  const loading = false;

  return isMobile ? (
    <PanelMobile title='Help' onBack={() => navigate(-1)}>
      {loading && (
        <div className='main_page__backdrop'>
          <Loader className='main_page__backdrop__loader' />
        </div>
      )}
      <HelpBody />
    </PanelMobile>
  ) : (
    <div className='main_page' style={{ overflowX: 'hidden' }}>
      <TickersDisplayBar />
      <Header />
      <HelpBody />
      <Modal />
      <Notifs />
      <AdblockChecker />
    </div>
  );
};

export default HelpPage;
